import axios from "axios";
import { getJwtTokenFromlocalStorage, clearAllPropsFromlocalStorage } from "core/utils/storage";
import { Navigate } from "react-router-dom";
import Swal from "sweetalert2";


const api = axios.create({
    //  baseURL: "http://127.0.0.1:5000/",
    // baseURL: "https://justclickindia.co.in/service_dce_test/"
    baseURL: "https://justclickindia.co.in/develop_api/"
    // baseURL: "https://justclickindia.co.in/service_dev_api/"
    // withCredentials: true,
})

api.interceptors.request.use(
    (config) => {
        const excludedPaths = [
            "/vendor_login/",
            "/vendor_register/register_vendor",
            "/services_register/register_service",
            "/otp_email/generate_mobile_otp",
            "/otp_email/generate_otp",
            "/otp_email/validate_otp",
            "/vendor_register/confirm_password",
            "/otp_email/login_check",
            "/service_management/service_specializations/get_specializations",
            "/service_management/service_types",
            "/vendor_management/business_category",
            "/check_duplicate_mobile",
            "/check_duplicate_email",
            "app_management/app_category",
            "/app_management/app_category/uploads/app_category/",
            "/payment_plans/get",
            "/razor_payments/",
            "/coupons/",
            "/vendor_register/renew_subscription",
            "/terms/latest"
        ];

        // if (excludedPaths.some(path => config.url?.endsWith(path))) {
        //     return config;
        // }

        if (excludedPaths.some(path => config.url?.endsWith(path)) || config.url?.startsWith("/razor_payments/")) {
            return config;
        }
        // config.withCredentials = true;

        const token = getJwtTokenFromlocalStorage()

        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`
        } else {
            clearAllPropsFromlocalStorage();
            // window.location.href = "/login";
            <Navigate to="/login" />
            return Promise.reject(new Error("Unauthorized: No token found"));
        }

        return config

    },
    (error) => {
        return Promise.reject(error)
    }
)


let lastCheckTime = null; // prevent checking too often

api.interceptors.response.use(
    async (response) => {
        try {
            const userType = localStorage.getItem("role"); // "Vendor", "Service Provider", "Admin"
            const email = localStorage.getItem("email");

            // Run check only for vendor/service provider and once every 10 minutes
            const now = Date.now();
            if ((userType === "Vendor" || userType === "Services") &&
                (!lastCheckTime || now - lastCheckTime > 10 * 60 * 1000)) {

                lastCheckTime = now;

                const subCheck = await api.get(
                    `/vendor_register/check_subscription?email_id=${email}&vendor_type=${userType}`
                );

                if (subCheck.data.plan_expired) {
                    Swal.fire({
                        icon: "warning",
                        title: "Subscription Expired",
                        text: "Please renew your subscription to continue.",
                        confirmButtonText: "Ok"
                    }).then(() => {
                        clearAllPropsFromlocalStorage();
                        window.location.href = `/payment-plans?email=${email}&vendor_type=${userType}`;

                    });
                }
            }
        } catch (err) {
            console.error("Subscription check failed", err);
        }
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            clearAllPropsFromlocalStorage();
            window.location.href = "/login";
        }
        return Promise.reject(error);
    }
);
export default api


